module.exports = __webpack_public_path__ + "img/data-view-usage-frequency.8ce9d6e3.svg";